import React from 'react'
import GloHero from '../Components/glodesk/GloHero'
import ProductOverview from '../Components/glodesk/ProductOverview'
import CoreCapabilities from '../Components/glodesk/CoreCapabilities'
import WhyGlodesk from '../Components/glodesk/WhyGlodesk'
import { ChevronRight } from 'lucide-react'
import CollaborateSection from '../Components/glodesk/CollaborateSection'
import WhoHero from '../Components/who/WhoHero'
import OverviewSection from '../Components/glodesk/OverviewSection'

import { Helmet } from "react-helmet-async";
import ContactSection from '../Components/home/ContactSection'

function GlodeskDummy() {
  return (
    <div>
      <Helmet>
    <title>
        Glodesk | Smart Coworking & Facility Management Software | Mobikode
    </title>

    <meta
        name="description"
        content="Glodesk is a smart coworking and facility management solution by Mobikode that helps businesses manage workspaces, facilities, operations, and everyday workplace activities efficiently."
    />

    <meta
        name="keywords"
        content="Glodesk, Glodesk Software, Coworking Management Software, Coworking Space Management, Facility Management Software, Workspace Management Software, Smart Workspace Management, Coworking Software, Facility Management Solutions, Workplace Management Software, Office Management Software, Digital Workspace Management, Coworking Technology, Workspace Automation, Facility Operations Management"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/glodesk"
    />

    <meta
        property="og:title"
        content="Glodesk | Smart Coworking & Facility Management Software | Mobikode"
    />

    <meta
        property="og:description"
        content="Manage coworking spaces and facilities more efficiently with Glodesk, a smart workspace and facility management solution from Mobikode."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/glodesk"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/lab/bg3.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="Glodesk | Smart Coworking & Facility Management Software | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Glodesk helps make coworking and facility management smoother, more organized, and easier to manage through smart digital solutions."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/lab/bg3.png"
    />
</Helmet>
      <WhoHero
        title="Glodesk"
        text="Smarter coworking and facility management that makes your workspace run smoothly, stay organized, and feel effortless to manage every day."
        imgData="/assets/lab/bg3.png"
      />
      <OverviewSection />
      <CoreCapabilities />
      <WhyGlodesk />
      {/* <CollaborateSection /> */}
      <ContactSection />
      {/* <GloHero />
      <ProductOverview />
       */}
    </div>
  )
}

export default GlodeskDummy
